import {
  Box,
  ColumnLayout,
  SpaceBetween,
  Grid,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as awsui from "@cloudscape-design/design-tokens";
import { GlobalContext } from "../context";
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';


export default function NewsStories() {
  const navigate = useNavigate();
  const { 
    theme, setTheme, 
  } = useContext(GlobalContext);

  const isSmallDevice = useMediaQuery({query: "only screen and (max-width : 768px)"});
  const isMediumDevice = useMediaQuery({query: "only screen and (min-width : 769px) and (max-width : 992px)"});
  const isLargeDevice = useMediaQuery({query: "only screen and (min-width : 993px) and (max-width : 1200px)"});
  const isDesktop = useMediaQuery({query: "only screen and (min-width : 1201px)"});


  const NewsStoryStyledDiv = styled.div`
    cursor: pointer;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;

    :hover {
      box-shadow: 5px 5px 10px grey;
    }
  `

  const Story_1 = () => {
    return (
      <>
        <Box>
          <center>
            <img
              src="/images/announcements/s5000-r2-01.png"
              alt="S5000"
              width="100%"
            />
          </center>
        </Box>
        <Box>
        <center><h5>Formula Renault 3.5</h5></center>
        The S5000 Series utilises the iRacing Formula Renault 3.5. Both are very similar in size and performance and both feature 'Push to Pass'.<p />
        <br />
        <b>ENGINE</b> 3.4 Litre V8<p />
        <b>GEARBOX</b> 6-speed<p />
        sequential, paddle shift<p />
        <b>WEIGHT</b> 711 Kg<p />
        <b>POWER</b> 395 Kw<p />

        </Box>
      </>
    )
  }

  const Story_2 = () => {
    return (
      <>
        <Box>
          <center>
            <img
              src="/images/announcements/ffa-r2-01.png"
              alt="Formula Ford"
              width="100%"
            />
          </center>
        </Box>
        <Box>
        <center><h5>Ray FF1600</h5></center>
        The iRacing Formula Ford vehicle is based on the 2023 Ray FF1600, and is as close as you can get to racing in the real world Formula Ford.<p />
        <br />
        <b>ENGINE</b> Ford Kent 1.6 litre<p />
        <b>GEARBOX</b> Hewland LD 200 4 speed<p />
        <b>WEIGHT</b> 504kg <p />
        <b>POWER</b> 116hp<p />

        </Box>
      </>
    )
  }

  const Story_3 = () => {
    return (
      <>
        <Box>
          <center>
            <img
              src="/images/announcements/f4a-r1-01.png"
              alt="F4A"
              width="100%"
            />
          </center>
        </Box>
        <Box>
        <center><h5>F4</h5></center>
        The iRacing FORMULA 4 has been modelled on the latest international F4 as we've seen in international events from the start 2023.<p />
        <br />
        <b>ENGINE</b> 2.0L inline-4<p />
        <b>GEARBOX</b> 6-speed<p />
        sequential, paddle shift<p />
        <b>WEIGHT</b> 570 kg<p />
        <b>POWER</b> 160 hp<p />
        </Box>
      </>
    )
  }

  const Story_4 = () => {
    return (
      <>
        <Box>
          <center>
            <img
              src="/images/announcements/f3a-01.png"
              alt="F3A"
              width="100%"
            />
          </center>
        </Box>
        <Box>
          <center><h5>Dallara F3</h5></center>
          The Dallara F317 was designed for young drivers to move their way up through the world ranks of open-wheel racing.<p />
          <br />
          <b>ENGINE</b> 2.0L inline-4<p />
          <b>GEARBOX</b> 6-speed<p />
          sequential, paddle shift<p />
          <b>WEIGHT</b> 550 kg<p />
          <b>POWER</b> 220 hp<p />
        </Box>
      </>
    )
  }


  // if (!isMediumDevice) return (
  return (
    <>
      <center>
        <Box variant="h1" fontSize="heading-xl">
          The Vehicles
        </Box>
      </center>
      <SpaceBetween size="m">
        <Box>
          <Grid data-vehicles-grid
            gridDefinition={[
              { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
              { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
              { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
              { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
            ]}
          >  
            <Box padding={"xl"} >
              <NewsStoryStyledDiv>
                <SpaceBetween size="xxl">
                  <Story_1 />
                </SpaceBetween>
              </NewsStoryStyledDiv>
            </Box>
            <Box padding={"xl"} >
              <NewsStoryStyledDiv>
                <SpaceBetween size="xxl">
                  <Story_2 />
                </SpaceBetween>
              </NewsStoryStyledDiv>
            </Box>
            <Box padding={"xl"}>
              <NewsStoryStyledDiv>
                <SpaceBetween size="xxl">
                  <Story_3 />
                </SpaceBetween>
              </NewsStoryStyledDiv>
            </Box>
            <Box padding={"xl"}>
              <NewsStoryStyledDiv>
                <SpaceBetween size="xxl">
                  <Story_4 />
                </SpaceBetween>
              </NewsStoryStyledDiv>
            </Box>
          </Grid>
        </Box>
      </SpaceBetween>
    </>    
  );

  // return (
  //   <>
  //     <center>
  //       <Box variant="h1" fontSize="heading-xl">
  //         The Vehicles
  //       </Box>
  //     </center>
  //     <SpaceBetween size="m">
  //       <Box>
  //         <Grid
  //           gridDefinition={[
  //             { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
  //             { colspan: { default: 12, xxs: 8, xs: 6, m: 3 } },
  //           ]}
  //         >  
  //           <Box padding={"xl"} >
  //             <NewsStoryStyledDiv>
  //               <SpaceBetween size="xxl">
  //                 <Story_1 />
  //               </SpaceBetween>
  //             </NewsStoryStyledDiv>
  //           </Box>
  //           <Box padding={"xl"} >
  //             <NewsStoryStyledDiv>
  //               <SpaceBetween size="xxl">
  //                 <Story_2 />
  //               </SpaceBetween>
  //             </NewsStoryStyledDiv>
  //           </Box>
  //         </Grid>
  //       </Box>
  //     </SpaceBetween>
  //   </>    
  // );
}
